const API_PREFIX = '/api'
let api_url = process.env.MIX_API_URL
api_url = api_url
    ? api_url.trim('/')
    : ''

export const VEO_INDIVIDUAL_DATA = [
  'NA',
  'Individual',
  'Veo'
]
export const WORKING_STATUSES = {
  site: 'Site',
  ho: 'HO',
  other: 'Other'
}
export const WORKING_LOCATIONS_DATA = {
  site: WORKING_STATUSES.site,
  ho: WORKING_STATUSES.ho,
}
export const REASON_IF_NO_OBJ = {
  paid_day_off: 'Paid day-off',
  non_paid_day_off: 'Non-paid day-off',
  sick_leave: 'Sick leave',
}
export const REASON_IF_NO_DATA = [
  REASON_IF_NO_OBJ.paid_day_off,
  REASON_IF_NO_OBJ.non_paid_day_off,
  REASON_IF_NO_OBJ.sick_leave
]
export const BOOL_DATA = ({yes_text = 'Yes', no_text = 'No'}) => {
  return [
    {id: 1, title: yes_text},
    {id: 0, title: no_text},
  ]
}
export const MAX_HOUR = '10:00';

export default {
  api_url: `${api_url}${API_PREFIX}`,
  api_prefix: API_PREFIX,
  api_name: process.env.MIX_APP_NAME,
  user: {
    user: 'user',
    admin_role: 'admin',
    new_user: 'new_user'
  },
}
